import { createDeferred } from "common/utils/deferred";

export interface BakedMaterialsFileUrlHelper {
  getPostedFileURLByName(path: string): Promise<string | null>;
}

const deferred = createDeferred<BakedMaterialsFileUrlHelper>();

export const bakedMaterialsFileUrlHelper = deferred.promise;

export function setBakedMaterialsFileUrlHelper(helper: BakedMaterialsFileUrlHelper) {
  deferred.resolve(helper);
}
